import React from 'react';
import Header from './components/Header';
import ContentSection from './components/ContentSection';
import Footer from './components/Footer';
import FAQSection from './components/FAQSection';
import RelatedCalculators from './components/RelatedCalculators';
import IonizadoSection from './components/IonizadoSection';
import HeroSection from './components/HeroSection';

import DoutoBanner from './DoutoBanner';
function App() {
  return (
    <div className="site-shell">
      <Header />
      <main className="page-content">
        <HeroSection />
        <DoutoBanner />
        <div className="section-divider" />
        <ContentSection />
        <div className="section-divider section-divider-offset" />
        <IonizadoSection />
        <div className="section-divider" />
        <p className="guide-link"><a href="/calcio-corrigido-e-calcio-ionizado/">Limites do cálcio corrigido: perguntas e limitações →</a></p><RelatedCalculators />
        <div className="section-divider" />
        <FAQSection />
        <div className="section-divider section-divider-offset" />
      </main>
      <Footer />
    </div>
  );
}

export default App;
